import { DateTime } from 'luxon';

export default function getDateFromUtcDateTimeString(
  utcDateTimeString: string,
): string {
  return DateTime.fromISO(utcDateTimeString, { zone: 'utc' }).toISODate();
}
